import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { init } from './estoqueActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Button from '../../common/form/button';

class EstoqueMovForm extends Component {
  render() {
    const { handleSubmit } = this.props;
    const itens = this.props.itens || [];

    return (
      <form onSubmit={handleSubmit} autoComplete="off" className="simple-cad-form-premium manutencao-cad-premium estoque-mov-premium">
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-dolly" /> Movimentar Estoque
              </h4>
              <p>Registre entradas, saídas, devoluções ou ajustes de materiais.</p>
            </div>
            <div className="simple-cad-premium-body">
              <Field name="estoque_item_id" component={LabelAndSelectForm} label="Item" cols="12 6">
                <option value="">Selecione o item...</option>
                {itens.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.descricao} ({item.quantidade_atual} {item.unidade})
                  </option>
                ))}
              </Field>
              <Field name="tipo" component={LabelAndSelectForm} label="Tipo" cols="12 3">
                <option value="ENTRADA">Entrada</option>
                <option value="SAIDA">Saída</option>
                <option value="DEVOLUCAO">Devolução</option>
                <option value="AJUSTE">Ajuste</option>
              </Field>
              <Field
                name="quantidade"
                component={LabelAndInput}
                type="number"
                step="0.001"
                label="Quantidade"
                cols="12 3"
                placeholder="0"
              />
              <Field
                name="observacao"
                component={LabelAndInput}
                label="Observação"
                cols="12 12"
                placeholder="Opcional (ex.: nota fiscal, OS relacionada...)"
              />
            </div>
          </div>
        </div>
        <div className="simple-cad-premium-footer">
          <Button type="submit" className="primary" icon="check" label="Registrar" />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

EstoqueMovForm = reduxForm({ form: 'estoqueMovForm', destroyOnUnmount: false })(EstoqueMovForm);
const mapStateToProps = state => ({ itens: state.manutencaoEstoque.list });
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EstoqueMovForm);
